import { render, staticRenderFns } from "./ChartTest2.vue?vue&type=template&id=cd53555c&scoped=true"
import script from "./ChartTest2.vue?vue&type=script&lang=js"
export * from "./ChartTest2.vue?vue&type=script&lang=js"
import style0 from "./ChartTest2.vue?vue&type=style&index=0&id=cd53555c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd53555c",
  null
  
)

export default component.exports